<template>
  <v-menu
    v-model="showMenu"
    top
    left
    :nudge-left="20"
    :nudge-top="20"
    min-width="300px"
    max-width="300px"
    max-height="400px"
    :position-x="xShowPosition"
    :position-y="yShowPosition"
    absolute
  >
    <v-card-subtitle v-if="propsMenuItems.length>0" class="primary white--text text-lg font-weight-bold" style="position: fixed;top: 0;left:0;width: 100%;">您可以这样问：</v-card-subtitle>
    <div style="height:45px" v-if="propsMenuItems.length>0"></div>
     <v-card-subtitle v-if="propsMenuItems.length==0" class="primary white--text text-lg font-weight-bold">还未配置建议问题</v-card-subtitle>
    <v-list max-height="355" style="overflow:auto">
      <v-list-item
        v-for="prompt in propsMenuItems"
        :key="prompt.Id"
        @click="onSelect(prompt)"
      >
        <v-list-item-content>
          <v-list-item-subtitle class="text-xs">{{
            prompt.Stem
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)

//例如: import <组件名称> from  <组建路径>
export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    propsBot: {
      type: Object,
      required: false,
    },
    propsMenuItems: {
      type: Array,
      required: true,
    },
    prompstotalCount:{
      type: String,
      required: false,
    }
  },
  data() {
    //这里存放数据
    return {
      showMenu: false,
      xShowPosition: 0,
      yShowPosition: 0,
    };
  },
  //计算机属性 类似与data概念
  computed: {},
  //监控data中数据变化
  watch: {},
  methods: {
    funcShowMenu(e) {
      this.showMenu = true;
      this.xShowPosition = e.clientX;
      this.yShowPosition = e.clientY;
    },
    onSelect(prompt) {
      this.$emit("selectPrompt", prompt.Stem);
    },
  },
  //生命周期-创建完成(可以访问当前this实例)
  created() {},
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {},
  destroyed() {}, //生命周期-销毁完成
  activated() {}, //如果页面有keep-alive,这函数会触发
};
</script>

<style lang="scss">
.text-lg{
  font-size: 0.9rem !important;
  line-height:0.9rem !important
}
.v-menu__content:not(.list-style) .v-list-item{
  padding-left: 19px;
}
.v-menu__content{
  overflow: hidden !important;
}

</style>
